import React from 'react';
import { Modal } from 'react-bootstrap';

const CommonModal = ({ show, handleOnHide, title, content, size = 'lg' }) => {
	return (
		<Modal size={size} show={show} onHide={handleOnHide} aria-labelledby="example-modal-sizes-title-lg">
			<Modal.Body>{content}</Modal.Body>
		</Modal>
	);
};

export default CommonModal;
